import { render, staticRenderFns } from "./GiftVendorModal.vue?vue&type=template&id=6c16b93d&"
import script from "./GiftVendorModal.vue?vue&type=script&lang=js&"
export * from "./GiftVendorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c16b93d')) {
      api.createRecord('6c16b93d', component.options)
    } else {
      api.reload('6c16b93d', component.options)
    }
    module.hot.accept("./GiftVendorModal.vue?vue&type=template&id=6c16b93d&", function () {
      api.rerender('6c16b93d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/carnival/orderMgt/modules/GiftVendorModal.vue"
export default component.exports